import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import secureLocalStorage from "react-secure-storage";

const firebaseConfig = {
  apiKey: "AIzaSyDu7AjVlr3i9gs5cLs7LjxmtJB6QBYuzWE",
  authDomain: "playmatez-38cf6.firebaseapp.com",
  databaseURL: "https://playmatez-38cf6-default-rtdb.firebaseio.com",
  projectId: "playmatez-38cf6",
  storageBucket: "playmatez-38cf6.firebasestorage.app",
  messagingSenderId: "109442322016",
  appId: "1:109442322016:web:d0915b6151d40590933d05",
  measurementId: "G-4LB8BQ466Q",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const analytics = getAnalytics(app);
export const messaging = getMessaging(app);

// // Register service worker (after messaging is initialized)
// if ("serviceWorker" in navigator) {
//   navigator.serviceWorker
//     .register("/firebase-messaging-sw.js")
//     .then((registration) => {
//       console.log("Firebase SW registered:", registration);
//     })
//     .catch((err) => console.log("SW registration failed:", err));
// }

// // Request FCM token
// export const requestForToken = async () => {
//   try {
//     const permission = await Notification.requestPermission();
//     if (permission === "granted") {
//       const token = await getToken(messaging, {
//         vapidKey:
//           "BMYaC3_2Kv_AXwCMcXitE-W0kNxt6tMLPmMRkZNL8jvkqdJaWHFmYtV7aI1IA3imrSJyb9ne7An7yULYdYXKSMM",
//       });
//       console.log("FCM Token:", token);
//       secureLocalStorage.setItem(process.env.REACT_APP_FCM_TOKEN_KEY, token);
//       // TODO: send token to backend for push notifications
//     } else {
//       console.log("Notification permission not granted");
//     }
//   } catch (err) {
//     console.error("FCM token error:", err);
//   }
// };

// // Foreground listener
// export const onMessageListener = () =>
//   new Promise((resolve) => {
//     onMessage(messaging, (payload) => {
//       console.log("FCM Payload:", payload);
//       resolve(payload);
//     });
//   });
